//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faMeEarth } from '@motionelements/assets/src/js/me-font/icons-channels2022';

import NavLogo from './NavLogo.vue';
import MenuLanguageNavDropdown from './MenuLanguageNavDropdown.vue';

export default {
  name: 'TheNavBarMinimal',
  components: {
    NavLogo,
    MenuLanguageNavDropdown,
    LanguagesList: () => import('@motionelements/core/src/components/modules/common/MenuLanguagesList.vue'),
    CustomSidebar: () => import('./CustomSidebar.vue'),
  },
  data() {
    return {
      faMeEarth,
    };
  },
};
